import { useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import PaymentCode from 'constants/payment-code';

/**
 * Custom hook for managing and updating menu visibility based on conditions.
 *
 * @param {Array} menuList - The list of modal menu items.
 * @callback setMenuList - The function to update the menuList state.
 */
export function useGetAccountElegibillity() {
  const isMounted = useRef(false);

  // State for eligibility flags
  const [isAccountingEligible, setIsAccountingEligible] = useState(false);
  const [isPaymentsEligible, setIsPaymentsEligible] = useState(false);
  const [isPaymentsUpdateEligible, setIsPaymentsUpdateEligible] =
    useState(false);
  const [isEverydayRewardsEligible, setIsEverydayRewardsEligible] =
    useState(false);

  // Selectors
  const accountingEnrolmentStatus = useSelector(
    (state: any) => state.accountingIntegrationStore.enrolmentStatus
  );
  const everydayRewardsEnrolmentStatus = useSelector(
    (state: any) => state.everydayRewardsStore.everydayRewardsEnrolmentStatus
  );
  const paymentType = useSelector(
    (state: any) => state.accountsStore.paymentType
  );
  const accountingEnrolmentStatusLoading = useSelector(
    (state: any) => state.accountingIntegrationStore.enrolmentStatusLoading
  );
  const everydayRewardsEnrolmentStatusLoading = useSelector(
    (state: any) =>
      state.everydayRewardsStore.everydayRewardsEnrolmentStatusLoading
  );
  const paymentTypeLoading = useSelector(
    (state: any) => state.accountsStore.paymentTypeLoading
  );

  useEffect(() => {
    if (isMounted.current) {
      if (!accountingEnrolmentStatusLoading) {
        setIsAccountingEligible(
          accountingEnrolmentStatus?.eligibilityStatus === 'Eligible'
        );
      }

      if (!paymentTypeLoading) {
        setIsPaymentsEligible(
          paymentType &&
            [
              PaymentCode.CREDIT_CARD_PAYMENT,
              PaymentCode.BANK_ACCOUNT_PAYMENT,
            ].includes(paymentType.paymentTypeCode)
        );

        setIsPaymentsUpdateEligible(
          paymentType &&
            [
              PaymentCode.DEFAULT_PAYMENT,
              PaymentCode.CREDIT_CARD_PAYMENT,
              PaymentCode.BANK_ACCOUNT_PAYMENT,
            ].includes(paymentType.paymentTypeCode)
        );
      }

      if (!everydayRewardsEnrolmentStatusLoading) {
        setIsEverydayRewardsEligible(
          everydayRewardsEnrolmentStatus?.eligibilityStatus === 'Eligible'
        );
      }
    }

    isMounted.current = true;
  }, [
    accountingEnrolmentStatusLoading,
    everydayRewardsEnrolmentStatusLoading,
    paymentTypeLoading,
  ]);

  return {
    isAccountingEligible,
    isPaymentsEligible,
    isPaymentsUpdateEligible,
    isEverydayRewardsEligible,
  };
}
